import { ORDER_LOOKUP, brand } from 'config';
import { useEnvPropsStore } from '~/stores/useEnvPropsStore.js';

// Returns date in "Aug 9, 2023" format
const monthDateYearFormat = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-US', options);
};

// Returns date in "Wed 8/29" format
const dayMonthDateFormat = (dateString) => {
  const date = new Date(dateString);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayName = days[date.getDay()];
  const month = date.getMonth() + 1; // Months are zero-based
  const day = date.getDate();
  return `${dayName} ${month}/${day}`;
};

const formatDate = (dateString = '') => {
  if (!dateString) return '';
  if (brand === 'bcom') return dayMonthDateFormat(dateString);
  return monthDateYearFormat(dateString);
};

const padStart = (value) => value?.toString().padStart(9, '0');

const digitsOnly = (e) => {
  const char = String.fromCharCode(e.keyCode);
  if (/^[0-9]+$/.test(char)) return true;
  return e.preventDefault();
};

const isSafariBrowser = (userAgent) => /^((?!chrome|android).)*safari/i.test(userAgent);

const validateOrderNumber = (orderNumber) => {
  if (!orderNumber) return ORDER_LOOKUP.noOrderNumberMessage;
  if (orderNumber.length > 20) return ORDER_LOOKUP.maximumCharactersMessage;
  if (!/^[A-Za-z0-9]*$/.test(orderNumber)) return ORDER_LOOKUP.invalidOrderNumberMessage;
  return true;
};

const removeBrandFromName = (brandName, name = '') => {
  if (!brandName || !name) return name;
  if (name.indexOf(brandName) === 0) {
    const brandLength = brandName.split(' ').length;
    const splitname = name.split(' ');
    return splitname.slice(brandLength).join(' ');
  }
  return name;
};

const commaSeparate = (...args) => args.filter((arg) => arg).join(', ');

const getBaseUrl = () => {
  const envPropsStore = useEnvPropsStore();
  const wwwUrl = envPropsStore.envProps.wwwUrl;
  return import.meta.server ? `${wwwUrl}` : '';
};
export { getBaseUrl, padStart, digitsOnly, validateOrderNumber, isSafariBrowser, removeBrandFromName, formatDate, commaSeparate };
